/* eslint-disable max-lines-per-function */
import React, { useState } from 'react';
import { Form as FinalForm } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { Typography } from '@material-ui/core';
import MUITextField from '../../shared/components/MUITextField';
import MUIAutoComplete from '../../shared/components/MUIAutoComplete';
import { checkPermissions } from '#/permissions';
import { roles } from '#/constants';
import {
    menu, formatDateForComponent, formatDatePaidForComponent
} from '../orders/utils/utils';
import { Button } from 'semantic-ui-react';
import { useCreateOrUpdateOrder } from '../../api/orders';
import { isEmpty } from 'lodash';
import BulkInsert from './bulkInsert';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import dayjs from 'dayjs';


const styles = {
    formBoxBottom: {
        margin: '0px 0px',
        padding: '20px 0px',
        display: 'flex',
        justifyContent: 'flex-end'
    },
    formButton: {
        width: '500px',
        height: '10px'
    }
};

const FormBox = props => <Box sx={{
    my: 1
}}>{ props.children }</Box>;

const useUnitTypeField = props => {

    const [value, setValue] = useState(props.value);

    const Component = () => (

        <FormBox>
            <TextField name='unit_type' label='Unit Type' value={value} disabled sx={{ width: '100%' }} />
        </FormBox>
    );

    return {
        Component,
        setValue,
        value
    };
};


const FormSplit = props => (

    <Grid container columnSpacing={1}>
        <Grid item xs={6}>
            {props.left}
        </Grid>
        <Grid item xs={6}>
            {props.right}
        </Grid>
    </Grid>
);


const defaultTagValue = (values = {}, types, tags) => {

    if (values?.type){
        return values?.type;
    }

    if (!isEmpty(values) && values.source === 'Custom'){

        const amenity_type = types.find(x => x.type === values.amenity_name);
        const tag_name = tags.find(x => x.name === amenity_type.tag).name;

        return tag_name;
    }


    return '';
};

const SingleOrderForm = props => {

    const {
        initialValues,
        amenity_types,
        amenity_tags,
        allUnits
    } = props;

    const [tipo, setTipo] = React.useState(defaultTagValue(initialValues, amenity_types, amenity_tags));
    const [amenNameList, setAmenNameList] = useState(menu(tipo, amenity_types));

    const {
        Component: UnitTypeField,
        setValue: setUnitType
    } = useUnitTypeField({ value: initialValues?.unit_type });

    const isNew = !initialValues.unit_space_name;
    const isCustom = initialValues.source === 'Custom' || isEmpty(initialValues);
    const [paid, setPaid] = useState(initialValues.paid || false);
    const [date_paid, setDatePaid] = useState(initialValues.date_paid || null);

    const { mutate: createOrUpdateOrder } = useCreateOrUpdateOrder();


    // const units = props.arrayAll.map(e => e.unit_space_name);
    const unitsNoRepetitions = [...new Set(allUnits)];
    // const unit_for_menu = unitsNoRepetitions.map(e => ({
    //     value: e,
    //     label: e
    // }));

    const unit_for_menu = unitsNoRepetitions.map(e => ({
        value: e,
        label: e
    }));

    const types = [];
    amenity_tags.map(x => {

        types.push({
            key: x.name,
            value: x.name,
            label: x.name
        });

        return types;
    });

    const paid_menu = [{
        key: 'Yes',
        value: 'Yes',
        label: 'Yes'
    },
    {
        key: 'No',
        value: 'No',
        label: 'No'
    }];

    const handleUnitChange = event => {
        // const order_element = props.arrayAll.find(element => element.unit_space_name === event?.value);

        const unit_type = props.unitTypeMappings[event?.value];
        // const unit_type = `${getUnitType(order_element, props.unitTypeMappings)}`;

        setUnitType(unit_type);

        return null;
    };

    const handleTypeChange = value => {

        setTipo(value);
        setAmenNameList(menu(value, amenity_types));
    };

    const handlePaid = value => {

        if (value === 'Yes'){
            setPaid(true);
            setDatePaid(dayjs().format('YYYY-MM-DD').toString());
        }
        else if (value === 'No'){
            setPaid(false);
            setDatePaid(null);
        }
    };

    const onSubmit = async values => {

        // const order_element = props.arrayAll.find(element => element.unit_space_name === values.unit_space_name.value);
        // const order_element = props.arrayAll.find(element => element.unit_space_name === values.unit_space_name.value);
        const type_id = amenity_types.find(x => x.type === values.amenity_name);

        const payload = {
            id: initialValues.id,
            unit_space_name: values.unit_space_name.value || initialValues.unit_space_name,
            type_id: (type_id ? type_id.type_id : null),
            amenity_name: values.amenity_name,
            paid: values.paid === 'Yes',
            date_paid: date_paid ? formatDatePaidForComponent(values.date_paid) : date_paid,
            check_number: (values.check_number ? values.check_number : null),
            ordered: (values.ordered) ? formatDateForComponent(values.ordered) : null,
            manager_notes: (values.manager_notes ? values.manager_notes : null),
            owner_notes: (values.owner_notes ? values.owner_notes : null),
            lookup_code: props.lookup_code || initialValues.lookup_code,
            property_id: props.propertyId,
            original: {
                amenity_name: initialValues.amenity_name,
                lookup_code: initialValues.lookup_code,
                unit_space_name: initialValues.unit_space_name,
                type_id: initialValues.type_id,
                created_at: initialValues.created_at,
                property_id: props.propertyId
            }
        };

        if (isNew) {
            payload.custom = true;
        }

        await createOrUpdateOrder(payload);
        props.setModalOpen(false);

    };

    const isAdmin = checkPermissions([roles.admin, roles.regional_manager_admin], props.role);

    return (
        <FinalForm
            initialValues={initialValues}
            onSubmit={onSubmit}
            render={({
                handleSubmit, submitting, pristine, values, form: { mutators }
            }) => (
                <form onSubmit={handleSubmit}>


                    {isAdmin && (
                        <>
                            <Box sx={{ width: '100%' }} style={{ marginTop: '20px' }}>
                                <FormSplit
                                    left={(
                                        <FormBox>
                                            <MUIAutoComplete
                                                disablePortal
                                                variant='outlined'
                                                name='unit_space_name'
                                                label='Unit'
                                                freeSolo
                                                options={unit_for_menu}
                                                sx={{ width: 362 }}
                                                defaultValue={initialValues?.unit_space_name || ''}
                                                disabled={!isNew}
                                            />
                                            <OnChange name='unit_space_name' children={handleUnitChange} />
                                        </FormBox>
                                    )}
                                    right={(
                                        <UnitTypeField />
                                    )}
                                />
                                {isCustom && <FormSplit
                                    left={(
                                        <FormBox>
                                            <MUITextField
                                                name='type'
                                                label='Tag'
                                                menu={types || []}
                                                variant='outlined'
                                                select
                                                required={isNew}
                                                defaultValue={tipo}
                                                disabled={!isCustom}

                                            />
                                            <OnChange name='type' children={handleTypeChange} />
                                        </FormBox>
                                    )}
                                    right={(
                                        <FormBox>
                                            <MUITextField
                                                name='amenity_name'
                                                label={props.isCustom ? 'Type' : 'Amenity Name'}
                                                menu={amenNameList || []}
                                                variant='outlined'
                                                select
                                                required={isNew}
                                                defaultValue={initialValues.amenity_name}
                                                disabled={!isCustom}

                                            />
                                            <OnChange name='type' children={handleTypeChange} />
                                        </FormBox>
                                    )}
                                />}
                                <FormSplit
                                    left={(
                                        <FormBox>
                                            <MUITextField
                                                name='paid'
                                                label='Paid'
                                                defaultValue={initialValues?.paid || ''}
                                                variant='outlined'
                                                select
                                                menu={paid_menu}
                                            />
                                            <OnChange name='paid' children={handlePaid} />
                                        </FormBox>
                                    )}
                                    right={(
                                        <FormBox>
                                            {paid && paid !== 'No' && (<MUITextField
                                                id='date_paid'
                                                label='Date Paid'
                                                type='date'
                                                defaultValue={paid ? formatDatePaidForComponent(initialValues?.date_paid) : null}
                                                variant='outlined'
                                                name='date_paid'
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                            />
                                            )}
                                        </FormBox>
                                    )}
                                />
                                <FormSplit
                                    left={(
                                        <FormBox>
                                            <MUITextField
                                                name='check_number'
                                                label='Check N.'
                                                defaultValue={initialValues?.check_number}
                                                variant='outlined'
                                            />
                                        </FormBox>
                                    )}
                                    right={(
                                        <FormBox>
                                            <MUITextField
                                                id='ordered'
                                                label= 'Date Ordered'
                                                type='date'
                                                defaultValue={formatDateForComponent(initialValues?.ordered) || ''}
                                                variant='outlined'
                                                name='ordered'
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                            />
                                        </FormBox>
                                    )}
                                />

                                <FormSplit
                                    left={(
                                        <FormBox>
                                            <MUITextField
                                                name='manager_notes'
                                                label='Manager Notes'
                                                minRows={3}
                                                inputProps={{
                                                    maxLength: 255
                                                }}
                                                multiline
                                                defaultValue={initialValues?.manager_notes}
                                                variant='outlined'
                                            />
                                        </FormBox>
                                    )}
                                    right={(
                                        <FormBox>

                                            <MUITextField
                                                name='owner_notes'
                                                label='Owner Notes'
                                                minRows={3}
                                                inputProps={{
                                                    maxLength: 255
                                                }}
                                                multiline
                                                defaultValue={initialValues?.owner_notes}
                                                variant='outlined'
                                            />
                                        </FormBox>
                                    )}
                                />
                            </Box>
                        </>
                    )}

                    {!isAdmin && (
                        <>
                            <Box sx={{ width: '100%' }} style={{ marginTop: '20px' }}>
                                <FormSplit
                                    left={(
                                        <FormBox>
                                            <MUIAutoComplete
                                                disablePortal
                                                variant='outlined'
                                                name='unit_space_name'
                                                label='Unit'
                                                freeSolo
                                                options={unit_for_menu}
                                                sx={{ width: 362 }}
                                                defaultValue={initialValues?.unit_space_name || ''}
                                                disabled={!isNew}
                                            />
                                            <OnChange name='unit_space_name' children={handleUnitChange} />
                                        </FormBox>
                                    )}
                                    right={(
                                        <UnitTypeField />
                                    )}
                                />
                                {isCustom && <FormSplit
                                    left={(
                                        <FormBox>
                                            <MUITextField
                                                name='type'
                                                label='Tag'
                                                menu={types || []}
                                                variant='outlined'
                                                select
                                                required={isNew}
                                                defaultValue={tipo}
                                                disabled={!isCustom}

                                            />
                                            <OnChange name='type' children={handleTypeChange} />
                                        </FormBox>
                                    )}
                                    right={(
                                        <FormBox>
                                            <MUITextField
                                                name='amenity_name'
                                                label={props.isCustom ? 'Type' : 'Amenity Name'}
                                                menu={amenNameList || []}
                                                variant='outlined'
                                                select
                                                required={isNew}
                                                defaultValue={initialValues.amenity_name}
                                                disabled={!isCustom}

                                            />
                                            <OnChange name='type' children={handleTypeChange} />
                                        </FormBox>
                                    )}
                                />}
                                <FormSplit
                                    left={(
                                        <FormBox>
                                            <MUITextField
                                                name='check_number'
                                                label='Check N.'
                                                defaultValue={initialValues?.check_number}
                                                variant='outlined'
                                            />
                                        </FormBox>
                                    )}
                                    right={(
                                        <FormBox>
                                            <MUITextField
                                                id='ordered'
                                                label= 'Date Ordered'
                                                type='date'
                                                defaultValue={formatDateForComponent(initialValues?.ordered) || ''}
                                                variant='outlined'
                                                name='ordered'
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                            />
                                        </FormBox>
                                    )}
                                />
                                <FormSplit
                                    left={(
                                        <FormBox>
                                            <MUITextField
                                                name='manager_notes'
                                                label='Manager Notes'
                                                minRows={3}
                                                inputProps={{
                                                    maxLength: 255
                                                }}
                                                multiline
                                                defaultValue={initialValues?.manager_notes}
                                                variant='outlined'
                                            />
                                        </FormBox>
                                    )}
                                    right={(
                                        <FormBox/>
                                    )}
                                />
                            </Box>
                        </>
                    )}
                    <div style={styles.formBoxBottom}>
                        <Button negative onClick={() => props.setModalOpen(false)}>
                            Cancel
                        </Button>
                        <Button floated='right' positive disabled={submitting || pristine}>
                            Submit
                        </Button>

                    </div>
                </form>
            )}
        />
    );
};

const OrderCommentForm = props => {

    const {
        initialValues,
        bulkInsert,
        toggleBulkInsert
    } = props;

    const title = () => {

        if (initialValues.unit_space_name){

            return 'Edit Order';
        }

        return 'New Order';
    };

    const marginBulk = bulkInsert ? '78%' : '65%';

    return (
        <>
            <Grid item >
                <div style={{ display: 'flex' }}>
                    <Typography variant='h5'>{ title() } </Typography>
                    {!bulkInsert && title() === 'New Order' && <FormGroup style={{ marginLeft: marginBulk }}>
                        <FormControlLabel control={<Switch />} label='Inserting Bulk' onClick={toggleBulkInsert}/>
                    </FormGroup>}
                </div>
            </Grid>

            { !bulkInsert && (<SingleOrderForm {...props} />) }
            { bulkInsert && (<BulkInsert {...props} />) }

        </>
    );
};

export default OrderCommentForm;
